'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$() {
  this.aSv = null;
  this.aSw = false;
  this.aSp = null;
  this.aSq = false;
  this.aSr = null;
  this.aSs = false;
  this.aSt = null;
  this.aSu = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeBigDecimal__$init$__V(this);
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$.prototype = $p;
$p.o3 = (function() {
  if ((!this.aSw)) {
    this.aSv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$3(this);
    this.aSw = true;
  }
  return this.aSv;
});
$p.iq = (function() {
  if ((!this.aSq)) {
    this.aSp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aSq = true;
  }
  return this.aSp;
});
$p.J2 = (function(x$0) {
});
$p.jh = (function() {
  if ((!this.aSs)) {
    this.aSr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var $x_1 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$();
      var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_package$().ox();
      var e$proxy7 = $x_1.iu(this$1.pp(1, this$1.hX));
      if ((e$proxy7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy7.bj) + ")"));
      }
      if ((e$proxy7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        return e$proxy7.aI;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy7);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aSs = true;
  }
  return this.aSr;
});
$p.Jm = (function() {
  if ((!this.aSu)) {
    this.aSt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Unit Price";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aSu = true;
  }
  return this.aSt;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$, "app.data.data_point_types$package$UnitPrice$", ({
  GB: 1,
  B: 1,
  C: 1,
  cz: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$UnitPrice$ };
//# sourceMappingURL=app.data.data_point_types$package$-Unit-Price$.js.map
